<style lang="scss" scoped>  @import "../../styles/labels"; </style>
<template>
  <div class="fed-small-label">
    <v-container class="page-break full-page-portrait ma-0 pa-0">
      <v-layout
        column
        fill-height
        justify-space-between

      >
      <div class="pt-3 customer-name"> {{ customerName }}</div>
          <div class="logo"><img src="@/assets/FED_Logo03.svg" width="25%"/></div>
          <div class="customer-name">
            {{ customerName }}
            <template v-if="bins && bins.length>0">
              <br/>
              <v-chip outline small v-for="(bin,i) of bins" v-bind:key="i">{{bin}}</v-chip>
            </template>

          </div>
          <div class="pb-3">
            <v-layout row justify-space-between>
              <span class="bags"> {{ bagText }}</span>
              <span style="width: auto"></span>
              <span class="driver">{{ driver }}</span>
            </v-layout>
          </div>
        </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'ShipLabel',
  props: {
    driver: String,
    customerName: String,
    bags: {},
    bagSize: String,
    bins: {}
  },
  methods: {
    capitalise(str) {
      if (!str) {
        return '';
      }
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  computed: {
    bagText() {
      return `${this.bags || ''}`
        + (this.bagSize === 'large' ? ' *' : '')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/ShipLabel.vue